import { CardGrid } from '@iheartjane/menu';
import { Flex, useMobileMediaQuery } from '@iheartjane/reefer';

import type { MenuProductGridProps } from '../menuProductGrid/menuProductGrid.types';

export const EmptyMenuProductGrid = ({
  listView = false,
  ...props
}: Partial<MenuProductGridProps>) => {
  const isMobile = useMobileMediaQuery({});
  return (
    <Flex
      flexDirection="column"
      width="100%"
      alignItems="center"
      {...props}
      height={0}
      px={isMobile ? 24 : 64}
    >
      {/* id is used by useMyHigh to determine grid width for smart sort fetch */}
      <CardGrid id="empty-menu-product-grid" listView={listView}>
        {null}
      </CardGrid>
    </Flex>
  );
};
